import { Volume2, VolumeX } from "@/lib/icons";
import { useSound, play } from "./sound";

/**
 * Small icon button to mute/unmute the game sound effects. Persists across
 * sessions via localStorage. Plays a click on unmute so the user gets
 * immediate audible feedback.
 */
export default function SoundToggle({ className = "" }: { className?: string }) {
  const [muted, toggle] = useSound();
  const handle = () => {
    toggle();
    // After toggling, `muted` here is stale - but the new value is !muted.
    // Play feedback only when turning sound ON.
    if (muted) {
      // small delay so the new state is committed before play() checks it
      window.setTimeout(() => play("click"), 0);
    }
  };
  return (
    <button
      type="button"
      onClick={handle}
      aria-pressed={!muted}
      aria-label={muted ? "Unmute sound" : "Mute sound"}
      title={muted ? "Unmute sound" : "Mute sound"}
      className={`inline-flex items-center justify-center w-8 h-8 rounded-md border border-border bg-background hover:bg-accent text-muted-foreground hover:text-foreground transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring ${className}`}
    >
      {muted ? <VolumeX size={14} aria-hidden="true" /> : <Volume2 size={14} aria-hidden="true" />}
    </button>
  );
}